import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from './store'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker';
import ReactPWAInstallProvider, { useReactPWAInstall } from "react-pwa-install";
function PWACtrl() {

    const { pwaInstall, supported, isInstalled } = useReactPWAInstall();
    const handleClick = () => {

        pwaInstall({
            title: "نصب برنامه تحت وب",
            logo: "/android-icon-192x192.png",
            description: "برای داشتن تجربه کاربری بهتر، لطفا این وب سایت را روی گوشی خود نصب کنید.",
        })
            .then(() => alert("برنامه با موفقیت نصب شد."))
            .catch(() => alert("نصب برنامه لغو شد."));
    };

    return (
        <div>
            {supported() && !isInstalled() && (
                <button type="button" onClick={handleClick}>
                    نصب برنامه
                </button>
            )}
        </div>
    );
}

ReactDOM.render(
    <Provider store={store}>
        <ReactPWAInstallProvider enableLogging>
            <App />
            <PWACtrl />
        </ReactPWAInstallProvider>
    </Provider>,
    document.getElementById("root")
);
serviceWorker.register();